import { useContext, useState } from 'react';
import { Formik } from 'formik';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

import { AuthContext } from '../../contexts/auth';
import { useDeviceService } from '../../hooks';

import {
	HeaderLogin,
	TextfiedsBox,
	InputTextBox,
	GlobalContainerLogin,
	LoginContainer,
	BtnCnxn,
	BtnCnxnLoading,
	TextLegals,
	Legals,
} from './styles';
import appLogo from '../../assets/LogoQuizzbox.png';
import { LoadingSpinner } from '../../components';
import { InstallButton } from '../../components';

function Login() {
	const i18n = useTranslation();

	const { enqueueSnackbar } = useSnackbar();

	const { signIn } = useContext(AuthContext);

	const navigate = useNavigate();

	const { isBrowserDeviceAuthorized } = useDeviceService();
	const watchMedia = window.matchMedia('(display-mode: browser)');
	const [isApplicationRunningOnBrowser, setIsApplicationRunningOnBrowser] =
		useState(watchMedia.matches);

	const handleSubmitForm = async (values) => {
		try {
			const res = await signIn(values);

			if (res.status === 200) {
				enqueueSnackbar(`${i18n.t('successConnection')}`, {
					variant: 'success',
				});

				navigate('/remote');
			}
		} catch (e) {
			enqueueSnackbar(
				e.message !== '' ? e.message : `${i18n.t('errorGettingData')}`,
				{ variant: 'error' }
			);
		}
	};

	const renderInstallButton = () => {
		const isBrowserAuthorized = isBrowserDeviceAuthorized();
		watchMedia.addEventListener('change', (e) => {
			setIsApplicationRunningOnBrowser(e.matches);
		});

		return (
			isBrowserAuthorized && isApplicationRunningOnBrowser && <InstallButton />
		);
	};

	return (
		<GlobalContainerLogin>
			{renderInstallButton()}

			<HeaderLogin>
				<img
					style={{ objectFit: 'contain' }}
					src={appLogo}
					width="300"
					height="95"
					alt="logo"
				/>
			</HeaderLogin>
			<LoginContainer>
				<Formik
					initialValues={{
						email: '',
						password: '',
					}}
					onSubmit={(values) => handleSubmitForm(values)}
				>
					{({ handleChange, handleSubmit, values, isValid, isSubmitting }) => {
						return (
							<TextfiedsBox>
								<Box
									sx={{
										display: 'flex',
										flexWrap: 'wrap',
										flexDirection: 'column',
										alignContent: 'center',
									}}
								>
									<InputTextBox>
										<TextField
											id="Email"
											label={`${i18n.t('email')}`}
											variant="outlined"
											InputLabelProps={{
												shrink: true,
											}}
											type="email"
											fullWidth
											onChange={handleChange('email')}
											value={values.email}
										/>
									</InputTextBox>

									<InputTextBox>
										<TextField
											id="pass"
											label={`${i18n.t('password')}`}
											variant="outlined"
											InputLabelProps={{
												shrink: true,
											}}
											type="password"
											fullWidth
											onChange={handleChange('password')}
											value={values.password}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													handleSubmit();
												}
											}}
										/>
									</InputTextBox>
								</Box>

								<BtnCnxn>
									<Button
										sx={{
											backgroundColor: 'buttons.main',
											color: 'buttonsTextColors.main',
											width: {
												xs: '40vw',
												sm: '25vw',
												md: '20vw',
												lg: '15vw',
												xl: '10vw',
											},
										}}
										disabled={
											!isValid ||
											isSubmitting ||
											values.email === '' ||
											values.password === ''
										}
										variant="contained"
										type="submit"
										onClick={handleSubmit}
									>
										{`${i18n.t('connection')}`}
									</Button>

									<BtnCnxnLoading>
										{isSubmitting && <LoadingSpinner />}
									</BtnCnxnLoading>
								</BtnCnxn>
								<Legals>
									<a
										style={{
											textDecorationColor: 'gray',
										}}
										href="https://quizzbox.com/en/legal-notice/"
									>
										<TextLegals>{`${i18n.t('legals')}`}</TextLegals>
									</a>
								</Legals>
							</TextfiedsBox>
						);
					}}
				</Formik>
			</LoginContainer>
		</GlobalContainerLogin>
	);
}

export default Login;
